import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import * as React from 'react'

import { cn } from './utils'

const TooltipProvider = TooltipPrimitive.Provider

const TooltipLocal = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      collisionPadding={8}
      className={cn(
        'z-50 overflow-hidden rounded-lg border bg-popover px-2 py-1 text-xs text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export const Tooltip = ({
  children,
  content,
  delayDuration = 400,
  side = 'top',
  show = true,
  className,
}: {
  children: React.ReactNode
  content: React.ReactNode
  delayDuration?: number
  side?: 'top' | 'right' | 'bottom' | 'left'
  show?: boolean
  className?: string
  [key: string]: any
}) => (
  <TooltipProvider>
    <TooltipLocal delayDuration={delayDuration}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      {show && (
        <TooltipContent side={side} className={className}>
          {content}
        </TooltipContent>
      )}
    </TooltipLocal>
  </TooltipProvider>
)
